'use client'

import React from 'react'

import { cn } from '@/utilities/cn'

/** Длинный отзыв свернут до нескольких строк: решает сам читатель. */
const LONG = 520

export function ReviewCard({
  about,
  author,
  light,
  text,
}: {
  about?: string | null
  author: string
  light?: boolean
  text: string
}) {
  const long = text.length > LONG
  const [open, setOpen] = React.useState(false)

  return (
    <figure
      className={cn(
        'flex break-inside-avoid flex-col gap-4 rounded-2xl p-6',
        light ? 'bg-white/8 text-sand' : 'bg-white/45 text-ink',
      )}
    >
      <blockquote className={cn('whitespace-pre-line', long && !open && 'line-clamp-[10]')}>{text}</blockquote>

      {long && (
        <button
          className={cn('self-start underline underline-offset-4', light ? 'text-sun' : 'text-punch')}
          onClick={() => setOpen((v) => !v)}
          type="button"
        >
          {open ? 'Свернуть' : 'Читать целиком'}
        </button>
      )}

      <figcaption className={cn('mt-auto font-display text-sm uppercase tracking-wide', light ? 'text-sand/70' : 'text-ink/60')}>
        {author}
        {about ? <span className={cn('block normal-case tracking-normal', light ? 'text-sand/50' : 'text-ink/45')}>{about}</span> : null}
      </figcaption>
    </figure>
  )
}
